{
  "steplist": "Lista koraka"
}
